import { ObjectMap } from '@ringcentral-integration/core/lib/ObjectMap';

export const regionSettingsMessages = ObjectMap.prefixKeys(
  ['saveSuccess', 'dialingPlansChanged', 'areaCodeInvalid'],
  'regionSettingsMessages',
);
